import { render } from "./autoReply.vue?vue&type=template&id=965dba46"
import script from "./autoReply.vue?vue&type=script&lang=js"
export * from "./autoReply.vue?vue&type=script&lang=js"

import "./autoReply.vue?vue&type=style&index=0&id=965dba46&lang=scss"
script.render = render

export default script